// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i_0c","top":"styles_top__3kteJ","left":"styles_left__57blT","description":"styles_description__1gKx4"};